import { pendingInviteInitialData } from '../types/InitialData';

export type PendingInviteTableType = {
  invitationId: number
  invitationTeamId: number
  invitationName: string
  invitationEmail: string
  invitationDateSent: string
  invitationRole: string
  invitationWpNonce: {
    invitationResend: string
    invitationRevoke: string
    invitationSetAsManager: string
    invitationSetAsMember: string
  }
}

const convertToPendingInviteReport = (data: pendingInviteInitialData): PendingInviteTableType[] => {

  const pendingInvites = data?.pending_invites ?? []

  const pendingInvitesData = pendingInvites.map( pendingInvite => ({
    invitationId: pendingInvite.invitation_id ?? 0, // Replace 0 with appropriate default value
    invitationTeamId: pendingInvite.invitation_team_id ?? 0,
    invitationName: pendingInvite.invitation_name ?? '',
    invitationEmail: pendingInvite.invitation_email ?? '',
    invitationDateSent: pendingInvite.invitation_date_sent ?? '',
    invitationRole: pendingInvite.invitation_role ?? '',
    invitationWpNonce: {
      invitationResend: pendingInvite.invitation_wpnonce.invitation_resend ?? '',
      invitationRevoke: pendingInvite.invitation_wpnonce.invitation_revoke ?? '',
      invitationSetAsManager: pendingInvite.invitation_wpnonce.invitation_set_as_manager ?? '',
      invitationSetAsMember: pendingInvite.invitation_wpnonce.invitation_set_as_member ?? ''
    }
  }));

  return pendingInvitesData;

}

export const PendingInviteTableData = (data: pendingInviteInitialData): PendingInviteTableType[] => {
  return convertToPendingInviteReport(data)
}
